import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: 'Isn’t all of this free on YouTube already?',
  a: 'The drills are. What’s not free is a whole season already sequenced into ready-to-run practices, by age, with a real warm-up and game situations — so you’re not spending your evenings stitching videos into a plan. You’re not paying for drills; you’re paying to never build a practice from scratch again.'
}, {
  q: 'I’ve never coached softball before. Is this too advanced for me?',
  a: 'It’s built for exactly that. Volume 01 gives you the 4-Block Practice System and your first six practices already built. Softball Decoded covers the jargon, Rules Made Simple covers the rules, and the Parent-Helper Playbook lets a parent with zero softball experience run a station.'
}, {
  q: 'Will it fit the age and level of my team?',
  a: 'Yes. Practices and drills come in three levels — 6U–8U, 10U–12U and HS & rec — with how to simplify each one or make it harder, so the same pack works whether you’ve got first-time 8U players or a high school roster.'
}, {
  q: 'What if I’m the only coach, or I only get the field for 45 minutes?',
  a: 'Covered. Volume 01 includes a 45-minute plan for when you get the field late, a plan for one coach with 14 players and a rainy-day indoor practice — and Volumes 02 to 05 each include a single-coach version of their practices.'
}, {
  q: 'I don’t have time to read 300 pages. Do I have to?',
  a: 'No. You don’t read it cover to cover — you open it to the practice you need and run that one plan. Each volume ends with a one-page field card for quick access by goal.'
}, {
  q: 'Is it printable or digital only?',
  a: 'Digital PDFs, laid out for printing. Most coaches print the plan for the day and keep it on a clipboard at the field.'
}, {
  q: 'What about safety — arms, pitchers and sliding?',
  a: 'Built in. Every practice opens with its own warm-up and throwing progression, Volume 05 covers pitch counts and rest for pitchers, and sliding is taught as a progression on a soft surface. It’s a coaching resource, not medical advice — always follow your league’s rules and refer injuries to a professional.'
}, {
  q: 'How do I get it?',
  a: 'Instant download after checkout, plus an email with your files. Lifetime access to what you bought.'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(null);
  return <section aria-labelledby="faq-heading" className="w-full bg-ice text-ink" data-id="element-97" data-mp="28gcg4p0p2d69">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20" data-id="element-98" data-mp="23h99x18za0wp">
        <div className="text-center" data-id="element-99" data-mp="23fpufcv5btvz">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-100" data-mp="1zg7ih6layt5a">
            Before you buy
          </p>
          <h2 id="faq-heading" className="chalk-underline mt-3 font-display font-bold uppercase text-ink text-4xl sm:text-5xl" data-id="element-101" data-mp="s3f5xinfqjxc">
            Frequently asked questions
          </h2>
        </div>

        <div className="mt-8 grid gap-2.5" data-id="element-102" data-mp="2zpyrfqvbqb30">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.q} className="overflow-hidden rounded-xl border border-ice-dark bg-white" data-id="element-103" data-mp="38oaitv40lcwi" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left text-[15px] font-bold text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-clay" data-id="element-104" data-mp="3dgtwst6m6a1u">
                  {faq.q}
                  {isOpen ? <MinusIcon className="h-5 w-5 flex-none text-clay" aria-hidden="true" data-id="element-105" data-mp="1x1ahruxumfee" /> : <PlusIcon className="h-5 w-5 flex-none text-clay" aria-hidden="true" data-id="element-106" data-mp="2203zjzk64skd" />}
                </button>
                {isOpen && <p className="px-4 pb-4 text-sm text-ink-soft" data-id="element-107" data-mp="16sa0yc3uvex4">{faq.a}</p>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}